import { render, staticRenderFns } from "./houseFormItem.vue?vue&type=template&id=2ad63494&scoped=true&"
import script from "./houseFormItem.vue?vue&type=script&lang=js&"
export * from "./houseFormItem.vue?vue&type=script&lang=js&"
import style0 from "./houseFormItem.vue?vue&type=style&index=0&id=2ad63494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad63494",
  null
  
)

export default component.exports